module.exports = __webpack_public_path__ + "static/4-3-adc922eded1dfd1151bb11ea213f63e4.png";